.search {
  width: 100%;
}
